/*------------------------------------*\
    BABEL POLYFILL
\*------------------------------------*/
import "babel-polyfill";
import 'bootstrap/js/dist/util';
import 'bootstrap/js/dist/tab';

import $ from "jquery";

/*------------------------------------*\
    MODULES
\*------------------------------------*/
import TypeMate from 'typemate';
import BlogCarousel from './modules/blog-carousel';
import CourseCalculator from './modules/course-calculator';
import GroupSites from './modules/group-sites';
import Header from './modules/header';
import HeroCarousel from './modules/hero-carousel';
import SmoothScroll from './modules/smooth-scroll';
import Map from './modules/map';
import Modal from './modules/modal';
import ProgenyCarousel from './modules/progeny-carousel';
import StallionCarousel from './modules/stallion-carousel';
import StallionProfileNav from './modules/stallion-profile-nav';
import Tabs from './modules/tabs';
import TestimonialCarouselModule from './modules/testimonial-carousel';

/*------------------------------------*
    APP
\*------------------------------------*/
const app = {

    init() {
        this.noJs();
        this.nodelistPolyfill();
        this.bind();
        this.alwaysLoad();
    },

    bind() {

        // Load any items that need modules
        let modulePlaceHolders = [...document.querySelectorAll('[data-module]')];

        // No modules so bail
        if (!modulePlaceHolders.length) {
            return;
        }

        modulePlaceHolders.map((item) => {

            // Attempt to load any modules
            let modules = item.getAttribute('data-module');

            if (!modules.length) {
                return false;
            }

            // Split the modules into an array
            modules = modules.trim().split(',');

            // Loop and bind to relevant modules
            modules.map((module) => {

                switch (module.trim()) {

                    case 'blog-carousel':

                        let blogCarouselInstance = new BlogCarousel(item);

                        blogCarouselInstance.init();

                        break;

                    case 'course-calculator':

                        let calculatorInstance = new CourseCalculator(item);

                        calculatorInstance.init();

                        break;

                    case 'group-sites':

                        let groupSitesInstance = new GroupSites(item);

                        groupSitesInstance.init();

                        break;

                    case 'header':

                        let headerInstance = new Header(item);

                        headerInstance.init();

                        break;

                    case 'hero-carousel':

                        let heroCarouselInstance = new HeroCarousel(item);

                        heroCarouselInstance.init();

                        break;

                    case 'map':
                        let mapInstance = new Map(item);

                        mapInstance.init();

                        break;

                    case 'modal':

                        let modalInstance = new Modal(item);

                        modalInstance.init();

                        break;

                    case 'progeny-carousel':

                        let progenyCarouselInstance = new ProgenyCarousel(item);

                        progenyCarouselInstance.init();

                        break;

                    case 'smooth-scroll':

                        let smoothScrollInstance = new SmoothScroll(item);

                        smoothScrollInstance.init();

                        break;

                    case 'stallion-carousel':

                        let stallionCarouselInstance = new StallionCarousel(item);

                        stallionCarouselInstance.init();

                        break;

                    case 'stallion-profile-nav':

                        let stallionProfileNavInstance = new StallionProfileNav(item);

                        stallionProfileNavInstance.init();

                        break;

                    case 'tabs':

                        let tabsInstance = new Tabs(item);

                        tabsInstance.init();

                        break;

                    case 'testimonial-carousel':

                        let testimonialCarouselModuleInstance = new TestimonialCarouselModule(item);

                        testimonialCarouselModuleInstance.init();

                        break;
                }
            });
        });
    },

    alwaysLoad() {
        const body = document.getElementsByTagName("main")[0];
        const typeMateInstance = new TypeMate(body, {
            selector: 'li, p',
            ignoreClass: 'tabs__list-item'
        });
        typeMateInstance.apply();

        $('.custom-file-input').on('change', function() {
            let fileName = $(this).val().split('\\').pop();
            $(this).next('.custom-file-label').addClass("selected").html(fileName);
        });
    },

    noJs() {
        document.documentElement.classList.remove('no-js');
        document.documentElement.classList.add('js');
    },

    nodelistPolyfill() {
        if (window.NodeList && !NodeList.prototype.forEach) {
            NodeList.prototype.forEach = function (callback, thisArg) {
                thisArg = thisArg || window;
                for (var i = 0; i < this.length; i++) {
                    callback.call(thisArg, this[i], i, this);
                }
            };
        }
    }
};

// Launch
app.init();
